/* HWE figures: fade up and count percentages from 0 when scrolled into view.
   Runs only inside sections marked data-hwe-anim='true'. Works in the theme editor too. */
(function () {
  if (window.__hwePop) return;
  window.__hwePop = 1;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var styled = false;
  var io = null;

  function addStyle() {
    if (styled) return;
    styled = true;
    var st = document.createElement('style');
    st.textContent = '.hwe-pop{opacity:0;transform:translateY(14px);font-variant-numeric:tabular-nums;transition:opacity .6s ease-out,transform .6s ease-out}.hwe-stat b.hwe-pop{display:inline-block}.hwe-pop.is-in{opacity:1;transform:none}';
    document.head.appendChild(st);
  }

  function count(el, delay) {
    var m = /^\s*(\d+)\s*%\s*$/.exec(el.textContent);
    if (!m) return;
    var end = +m[1], t0 = null, d = 1200;
    el.textContent = '0%';
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / d, 1);
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = Math.round(end * eased) + '%';
      if (p < 1) requestAnimationFrame(step);
    }
    setTimeout(function () { requestAnimationFrame(step); }, delay);
  }

  function init(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var scope = root || document;
    var els = scope.querySelectorAll('[data-hwe-anim="true"] .hwe-big, [data-hwe-anim="true"] .hwe-stat b');
    if (!els.length) return;
    addStyle();
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          io.unobserve(el);
          var delay = +el.getAttribute('data-hwe-delay') || 0;
          el.style.transitionDelay = delay + 'ms';
          el.classList.add('is-in');
          count(el, delay);
        });
      }, { threshold: 0.4 });
    }
    Array.prototype.forEach.call(els, function (el) {
      if (el.classList.contains('hwe-pop')) return;
      el.classList.add('hwe-pop');
      var group = el.parentNode && el.parentNode.parentNode ? el.parentNode.parentNode.querySelectorAll('.hwe-big') : [];
      var idx = Array.prototype.indexOf.call(group, el);
      el.setAttribute('data-hwe-delay', idx > 0 ? idx * 150 : 0);
      io.observe(el);
    });
  }

  function start() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme editor: replay when a section is re-rendered after a setting change. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
